(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taiora-best-sellers-carousel"] && !Shopify.designMode) return;
  try {
    
  /* Single-product carousel navigation */
  (function() {
    var carousels = document.querySelectorAll('.taiora-bsc__carousel');
    carousels.forEach(function(carousel) {
      var slides = carousel.querySelectorAll('.taiora-bsc__slide');
      var prevBtn = carousel.querySelector('.taiora-bsc__arrow--prev');
      var nextBtn = carousel.querySelector('.taiora-bsc__arrow--next');
      if (slides.length < 2) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      var current = 0;

      function showSlide(index) {
        slides.forEach(function(slide) { slide.classList.remove('is-active'); });
        slides[index].classList.add('is-active');
        current = index;
        prevBtn.disabled = current === 0;
        nextBtn.disabled = current === slides.length - 1;
      }

      prevBtn.addEventListener('click', function() {
        if (current > 0) showSlide(current - 1);
      });

      nextBtn.addEventListener('click', function() {
        if (current < slides.length - 1) showSlide(current + 1);
      });

      showSlide(0);
    });
  })();

  /* AJAX Add to Cart */
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.taiora-bsc__form');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('.taiora-bsc__add-btn');
    if (btn.disabled) return;

    var idInput = form.querySelector('input[name="id"]');
    var variantId = idInput.value;
    var span = btn.querySelector('span');
    var originalText = span.textContent;
    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    btn.disabled = true;
    span.textContent = '...';

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Failed');
      return response.json();
    })
    .then(function() {
      span.textContent = '\u2713';

      return fetch(rootUrl + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function(r) { return r.json(); });
    })
    .then(function() {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            itemCount: 1,
            source: 'taiora-best-sellers-carousel'
          }
        }
      }));

      setTimeout(function() {
        span.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function() {
      span.textContent = originalText;
      btn.disabled = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taiora-brand-intro"] && !Shopify.designMode) return;
  try {
    
  /* Tab switching for brand intro section */
  (function() {
    function initTabs() {
      var tabButtons = document.querySelectorAll('.taiora-brand__tab');
      if (!tabButtons.length) return;

      tabButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var section = btn.closest('.taiora-brand');
          if (!section) return;

          /* Deactivate all tabs and panels */
          section.querySelectorAll('.taiora-brand__tab').forEach(function(t) {
            t.classList.remove('taiora-brand__tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          section.querySelectorAll('.taiora-brand__panel').forEach(function(p) {
            p.classList.remove('taiora-brand__panel--active');
          });

          /* Activate clicked tab and its panel */
          btn.classList.add('taiora-brand__tab--active');
          btn.setAttribute('aria-selected', 'true');

          var panelId = btn.getAttribute('aria-controls');
          var panel = document.getElementById(panelId);
          if (panel) {
            panel.classList.add('taiora-brand__panel--active');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTabs);
    } else {
      initTabs();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taiora-choose-elements"] && !Shopify.designMode) return;
  try {
    
  /* Mobile carousel: highlight centered card */
  (function() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var grids = document.querySelectorAll('.taiora-elements__grid');
    grids.forEach(function(grid) {
      var cards = grid.querySelectorAll('.taiora-elements__card');
      if (!cards.length) return;

      grid.classList.add('js-ready');

      /* Scroll to first card so it's centered */
      var firstCard = cards[0];
      var scrollLeft = firstCard.offsetLeft - (grid.offsetWidth - firstCard.offsetWidth) / 2;
      grid.scrollLeft = Math.max(0, scrollLeft);

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.intersectionRatio >= 0.6) {
            entry.target.classList.add('is-active');
          } else {
            entry.target.classList.remove('is-active');
          }
        });
      }, {
        root: grid,
        threshold: [0, 0.6]
      });

      cards.forEach(function(card) { observer.observe(card); });
      if (cards[0]) cards[0].classList.add('is-active');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taiora-collection-products"]) return;
  try {
    
  /* Mobile carousel: highlight centered card */
  (function() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var grids = document.querySelectorAll('.taiora-cp__grid');
    grids.forEach(function(grid) {
      var cards = grid.querySelectorAll('.taiora-cp__card');
      if (!cards.length) return;

      /* Scroll to first card so it's centered */
      var firstCard = cards[0];
      var scrollLeft = firstCard.offsetLeft - (grid.offsetWidth - firstCard.offsetWidth) / 2;
      grid.scrollLeft = Math.max(0, scrollLeft);

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.intersectionRatio >= 0.6) {
            entry.target.classList.add('is-active');
          } else {
            entry.target.classList.remove('is-active');
          }
        });
      }, {
        root: grid,
        threshold: [0, 0.6]
      });

      cards.forEach(function(card) { observer.observe(card); });
      if (firstCard) firstCard.classList.add('is-active');
    });
  })();

  /* AJAX Add to Cart */
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.taiora-cp__form');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('.taiora-cp__add-btn');
    if (btn.disabled) return;

    var idInput = form.querySelector('input[name="id"]');
    var variantId = idInput.value;
    var span = btn.querySelector('span');
    var originalText = span.textContent;
    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    btn.disabled = true;
    span.textContent = '...';

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Failed');
      return response.json();
    })
    .then(function() {
      span.textContent = '\u2713';

      return fetch(rootUrl + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function(r) { return r.json(); });
    })
    .then(function() {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            itemCount: 1,
            source: 'taiora-collection-products'
          }
        }
      }));

      setTimeout(function() {
        span.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function() {
      span.textContent = originalText;
      btn.disabled = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taiora-top-sellers"] && !Shopify.designMode) return;
  try {
    
  /* Mobile carousel: highlight centered card, fade adjacent ones */
  (function() {
    if (window.innerWidth > 749) return;

    var grids = document.querySelectorAll('.taiora-top-sellers__grid');
    grids.forEach(function(grid) {
      var cards = grid.querySelectorAll('.taiora-top-sellers__card');
      if (!cards.length) return;

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.intersectionRatio >= 0.6) {
            entry.target.classList.add('is-active');
          } else {
            entry.target.classList.remove('is-active');
          }
        });
      }, {
        root: grid,
        threshold: [0, 0.6]
      });

      cards.forEach(function(card) { observer.observe(card); });

      /* Mark the first card as active initially */
      if (cards[0]) cards[0].classList.add('is-active');
    });
  })();

  /* AJAX Add to Cart for Top Sellers */
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.taiora-top-sellers__form');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('.taiora-top-sellers__add-btn');
    if (btn.disabled) return;

    var idInput = form.querySelector('input[name="id"]');
    var variantId = idInput.value;
    var span = btn.querySelector('span');
    var originalText = span.textContent;
    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    btn.disabled = true;
    span.textContent = '...';

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Failed');
      return response.json();
    })
    .then(function(data) {
      span.textContent = '\u2713';

      /* Fetch updated cart to get item count */
      return fetch(rootUrl + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      /* Dispatch cart:update event for theme cart icon / cart drawer */
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            itemCount: 1,
            source: 'taiora-top-sellers'
          }
        }
      }));

      setTimeout(function() {
        span.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function() {
      span.textContent = originalText;
      btn.disabled = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taiora-wuxing-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Mobile carousel: highlight centered card */
  (function() {
    if (window.innerWidth > 749) return;

    var grids = document.querySelectorAll('.taiora-reviews__grid');
    grids.forEach(function(grid) {
      var cards = grid.querySelectorAll('.taiora-reviews__card');
      if (!cards.length) return;

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.intersectionRatio >= 0.6) {
            entry.target.classList.add('is-active');
          } else {
            entry.target.classList.remove('is-active');
          }
        });
      }, {
        root: grid,
        threshold: [0, 0.6]
      });

      cards.forEach(function(card) { observer.observe(card); });
      if (cards[0]) cards[0].classList.add('is-active');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
